// extracted by mini-css-extract-plugin
export default {"board":"qY9ySHRh","dots":"vWehpfhs","inner":"lberiV3i","header":"CTyHEUG2","kicker":"ebAWB9e1","title":"Dg2DUhxO","lede":"Un0m8TjX","wall":"Sqvl62ph","slot":"CWVykZlH"};